import React, { Component } from "react";
import CardForm from "Utils/Cards/CardForm";
import { ConsultaSobranteAlmacen } from "./components/ConsultaSobranteAlmacen";
import "./styles/InventarioOtrosAcopios.css";

class SobranteAlmacenConsulta extends Component {
    state = {
        nombreAlmacen: null,
    };

    regresar = () => {
        this.props.history.goBack();
    };

    setNombreAlmacen = (nombreAlmacen) => {
        this.setState({ nombreAlmacen });
    };

    render() {
        let titulo = "SOBRANTE DE ALMACÉN";

        if (this.state.nombreAlmacen) {
            titulo += `: ${this.state.nombreAlmacen}`;
        }

        return (
            <div className="mb-4 col-12" style={{ maxWidth: "95vw" }}>
                <CardForm
                    icon="inventario_activo"
                    titulo={titulo}
                    subtitulo=""
                    col="12"
                >
                    <ConsultaSobranteAlmacen
                        inventarioAlmacenId={this.props.match.params.id}
                        regresar={this.regresar}
                        setNombreAlmacen={this.setNombreAlmacen}
                    />
                </CardForm>
            </div>
        );
    }
}

export default SobranteAlmacenConsulta;
